<script setup lang="ts">
import { useI18n } from "vue-i18n";

import ButtonAlt from "@/dsComponents/buttons/ButtonAlt.vue";
import Modal from "@/dsComponents/modals/Modal.vue";

interface NonDelegableConfirmationModalProps {
    open: boolean;
    isLoadingRemoveFromAgency?: boolean;
    isLoadingConfirm?: boolean;
}

defineProps<NonDelegableConfirmationModalProps>();

const emit = defineEmits<{
    close: [];
    "remove-from-agency": [];
    confirm: [];
}>();

const { t } = useI18n();
</script>

<template>
    <Modal
        class="non-delegable-confirmation-modal"
        width="500px"
        :title="t('modals.nonDelegable.confirmation.title')"
        :open="open"
        close
        action
        @close="emit('close')"
    >
        <div class="non-delegable-confirmation-modal__warning">
            <i class="ti ti-alert-triangle non-delegable-confirmation-modal__warning-icon" />
            <div class="non-delegable-confirmation-modal__warning-content">
                <p class="typo-xxs-regular">{{ t("modals.nonDelegable.confirmation.warningGlobal") }}</p>
            </div>
        </div>

        <template #footer>
            <div class="non-delegable-confirmation-modal__footer">
                <ButtonAlt
                    type="neutral"
                    variant="ghost"
                    :label="t('modals.nonDelegable.confirmation.removeFromAgency')"
                    :loading="isLoadingRemoveFromAgency"
                    @click="emit('remove-from-agency')"
                />
                <ButtonAlt
                    type="error"
                    variant="filled"
                    :label="t('modals.nonDelegable.confirmation.confirm')"
                    :loading="isLoadingConfirm"
                    @click="emit('confirm')"
                />
            </div>
        </template>
    </Modal>
</template>

<style scoped lang="scss">
.non-delegable-confirmation-modal {
    &__warning {
        display: flex;
        align-items: flex-start;
        gap: var(--spacing-lg, 12px);
        padding: var(--spacing-md, 8px) var(--spacing-lg, 12px);
        border: 1px solid var(--red-lighter, #fdedf0);
        border-radius: var(--radius-xs, 4px);
        background: var(--red-lightest, #fef6f8);
    }

    &__warning-icon {
        flex-shrink: 0;
        line-height: var(--font-xxs-regular-line-height, 18px);
        color: var(--red-base, #e51940);
    }

    &__warning-content {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-md, 8px);
        color: var(--text-main-900, #00061a);

        p {
            margin: 0;
        }
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        gap: var(--spacing-lg, 12px);
    }
}
</style>
